<template>
    <div class="main">
        <div class="emp_left">
            <!-- <p class="emp_p">部门列表</p> -->

            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;"><b>部门列表</b></p>
            </div>

            <el-tree :data="departmentTree" node-key="id" default-expand-all :expand-on-click-node="false"
                :highlight-current="true" @node-click="selectDeptClick">
                <!-- <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span @click="() => editClick(node, data)">{{ node.label }}</span>
                </span> -->
            </el-tree>
        </div>

        <div class="emp_right">
            <!-- <p class="emp_p"><el-button round @click="openDrawer">新增员工</el-button></p>
            <p class="emp_p">员工列表</p> -->

            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;"><b>员工列表</b></p>
                <p style="display:inline;float: right;line-height: 22px;margin: 5px 0;">
                    <el-button round type="success" @click="openDrawer">添加员工</el-button>
                </p>
            </div>

            <el-table :data="empList" style="width: 100%">
                <el-table-column prop="employeeName" label="姓名" min-width="10%"></el-table-column>

                <el-table-column prop="label" label="部门" min-width="22%"></el-table-column>
                <el-table-column prop="roleDescription" label="角色" min-width="30%"></el-table-column>

                <el-table-column prop="status" label="状态" min-width="9%"></el-table-column>
                <el-table-column prop="createdTime" label="添加时间" min-width="20%"></el-table-column>

                <el-table-column fixed="right" label="操作" min-width="9%">
                    <template slot="header">
                        <el-tooltip class="item" effect="light" placement="top" content="公司归属者无法删除">
                            <span>操作</span>
                        </el-tooltip>
                    </template>

                    <template slot-scope="scope">
                        <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button> -->
                        <el-button @click="deleteClick(scope.row)" type="warning" round size="small"
                            v-if="scope.row.owner != 1">
                            {{ scope.row.owner == 1 ? '' : '删除' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div>
                <el-pagination background :page-size="10" :page-count="pageCount" layout="prev, pager, next" :total="total"
                    @current-change="pageClick" hide-on-single-page>
                </el-pagination>
            </div>

            <el-drawer title="添加员工" :visible.sync="drawerVisible" style="text-align: left;">
                <div>
                    <p style="display:inline-block;width:80px;text-align: center;">姓名</p>
                    <el-input placeholder="请输入" v-model="employeeName" clearable
                        style="display:inline-block;width:300px"></el-input>
                </div>
                <div>
                    <p style="display:inline-block;width:80px;text-align: center;">智模号</p>
                    <el-input placeholder="请输入" v-model="phone" clearable maxlength="11" show-word-limit
                        style="display:inline-block;width:300px"></el-input>
                </div>
                <div id="cancel_determine">
                    <el-button round @click="drawerVisible = false">取消</el-button>
                    <el-button round type="primary" @click="addEmp">确认</el-button>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import globalMethod from "@/method/globalMethod.js";

export default {
    name: "Employee",
    mixins: [globalMethod],
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            departmentTree: [],
            drawerVisible: false,
            employeeName: '',
            phone: '',
            empList: [],
            pageIndex:0,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        selectDeptClick(node, data) {
            // console.log('node')
            // console.log(node)

            this.$axios({
                method: "post",
                url: "/shiro/employee/getAll/deptId",
                data: {
                    deptId: node.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status === 200) {
                    this.$message({
                        type: 'success',
                        message: data.msg
                    })
                }

                this.empList = data.data
                for (let key in this.empList) {
                    this.empList[key].createdTime = this.$moment(this.empList[key].createdTime).format("YYYY-MM-DD HH:mm")
                    this.empList[key].status = this.empList[key].status == 1 ? '启用' : '禁用'
                }

            })
        },
        openDrawer() {
            this.employeeName = ''
            this.phone = ''
            this.drawerVisible = true
        },
        addEmp() {
            this.$axios({
                method: "post",
                url: "/shiro/employee/add",
                data: {
                    employeeName: this.employeeName,
                    phone: this.phone,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 200) {
                    this.addEmpDrawer = false
                }

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAll()
            })
        },
        getAll() {
            this.$axios({
                method: "post",
                url: "/shiro/employee/getAll",
                data: {
                    companyId: this.companyId,
                    pageIndex:this.pageIndex,
                    pageNum:10
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                this.empList = data.data
                this.total = this.empList[0].total
                for (let key in this.empList) {
                    this.empList[key].createdTime = this.$moment(this.empList[key].createdTime).format("YYYY-MM-DD HH:mm")
                    this.empList[key].status = this.empList[key].status == 1 ? '启用' : '禁用'
                }
            })
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeEmp(row)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        removeEmp(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/employee/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                
                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAll()
            })
        },
        pageClick(currentPage){
            // console.log('pageClick()')
            // console.log(currentPage)
            this.pageIndex=(currentPage-1)*10
            this.getAll()
        }
    },
    mounted() {
        this.getAll()

        this.departmentTree = this.getDepartmentTree({
            companyId: this.companyId
        }, this.token)
    }
}
</script>

<style>
.emp_left {
    width: 22%;
    height: 550px;
    display: inline;
    float: left;
    /* border-right: 1px solid #909399; */
}

.emp_right {
    width: 75%;
    display: inline;
    float: right;
}

/* .emp_p {
    position: relative;
    right: 5px;
    width: 120px;
    margin: 10px 0px 30px 0px;
} */
</style>